import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function TasksIcon({ className }: IconProps) {
  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1446)">
        <path
          d="M79.6901 90V4.09463C79.6901 1.82894 77.8578 0 75.588 0H4.1021C1.83227 0 0 1.82894 0 4.09463V79.0537C0 85.0864 4.89517 90 10.9663 90H79.6901Z"
          fill="#EAEDF8"
        />
        <path
          d="M11.1025 89.9999C16.4079 89.9999 20.7835 86.069 21.4672 80.9644C21.5766 80.1455 22.2602 79.5449 23.0807 79.5449H88.3587C89.3706 79.5449 90.1636 80.473 89.9722 81.4831C89.0697 86.342 84.8035 89.9999 79.6622 89.9999H11.1025Z"
          fill="#00C4B3"
        />
        <path
          d="M12.3882 15.9144C12.0874 15.9144 11.8139 15.8052 11.5951 15.5868L8.83305 12.8297C8.39549 12.393 8.39549 11.6832 8.83305 11.2465C9.27061 10.8097 9.98164 10.8097 10.3918 11.2465L12.3609 13.2119L16.9552 8.62591C17.3928 8.18915 18.1038 8.18915 18.514 8.62591C18.9516 9.06267 18.9516 9.77241 18.514 10.1819L13.1266 15.5595C12.9078 15.7779 12.6343 15.8871 12.3335 15.8871"
          fill="#00416B"
        />
        <path
          d="M12.3882 26.1783C12.0874 26.1783 11.8139 26.0691 11.5951 25.8507L8.83305 23.0936C8.39549 22.6569 8.39549 21.9472 8.83305 21.5104C9.27061 21.0736 9.98164 21.0736 10.3918 21.5104L12.3609 23.4758L16.9552 18.8898C17.3928 18.4531 18.1038 18.4531 18.514 18.8898C18.9516 19.3266 18.9516 20.0363 18.514 20.4458L13.1266 25.8234C12.9078 26.0418 12.6343 26.151 12.3335 26.151"
          fill="#00416B"
        />
        <path
          d="M12.3882 36.4422C12.0874 36.4422 11.8139 36.333 11.5951 36.1146L8.83305 33.3576C8.39549 32.9208 8.39549 32.2111 8.83305 31.7743C9.27061 31.3375 9.98164 31.3375 10.3918 31.7743L12.3609 33.7397L16.9552 29.1537C17.3928 28.717 18.1038 28.717 18.514 29.1537C18.9516 29.5905 18.9516 30.3002 18.514 30.7097L13.1266 36.0873C12.9078 36.3057 12.6343 36.4149 12.3335 36.4149"
          fill="#00416B"
        />
        <path
          d="M12.3882 46.7061C12.0874 46.7061 11.8139 46.5969 11.5951 46.3785L8.83305 43.6215C8.39549 43.1847 8.39549 42.475 8.83305 42.0382C9.27061 41.6015 9.98164 41.6015 10.3918 42.0382L12.3609 44.0036L16.9552 39.4177C17.3928 38.9809 18.1038 38.9809 18.514 39.4177C18.9516 39.8544 18.9516 40.5642 18.514 40.9736L13.1266 46.3512C12.9078 46.5696 12.6343 46.6788 12.3335 46.6788"
          fill="#00416B"
        />
        <path
          d="M63.254 13.212H26.2257C25.6241 13.212 25.1045 12.7207 25.1045 12.0928C25.1045 11.465 25.5967 10.9736 26.2257 10.9736H63.254C63.883 10.9736 64.3752 11.465 64.3752 12.0928C64.3752 12.7207 63.883 13.212 63.254 13.212Z"
          fill="#00C4B3"
        />
        <path
          d="M56.6906 23.4759H26.1984C25.5967 23.4759 25.0771 22.9846 25.0771 22.3567C25.0771 21.7289 25.5694 21.2375 26.1984 21.2375H56.6906C57.3196 21.2375 57.8119 21.7289 57.8119 22.3567C57.8119 22.9846 57.3196 23.4759 56.6906 23.4759Z"
          fill="#00C4B3"
        />
        <path
          d="M39.872 33.7399H26.1984C25.5967 33.7399 25.0771 33.2485 25.0771 32.6207C25.0771 31.9928 25.5694 31.5015 26.1984 31.5015H39.872C40.4737 31.5015 40.9933 31.9928 40.9933 32.6207C40.9933 33.2485 40.501 33.7399 39.872 33.7399Z"
          fill="#00C4B3"
        />
        <path
          d="M63.8009 44.0309H26.2257C25.6241 44.0309 25.1045 43.5395 25.1045 42.9117C25.1045 42.2838 25.5967 41.7925 26.2257 41.7925H63.8009C64.4299 41.7925 64.9222 42.2838 64.9222 42.9117C64.9222 43.5395 64.4299 44.0309 63.8009 44.0309Z"
          fill="#00C4B3"
        />
        <path
          d="M63.8009 64.5587H26.2257C25.6241 64.5587 25.1045 64.0674 25.1045 63.4395C25.1045 62.8117 25.5967 62.3203 26.2257 62.3203H63.8009C64.4299 62.3203 64.9222 62.8117 64.9222 63.4395C64.9222 64.0674 64.4299 64.5587 63.8009 64.5587Z"
          fill="#00C4B3"
        />
        <path
          d="M57.8119 54.2948H26.2257C25.6241 54.2948 25.1045 53.8034 25.1045 53.1756C25.1045 52.5478 25.5967 52.0564 26.2257 52.0564H57.8119C58.4409 52.0564 58.9331 52.5478 58.9331 53.1756C58.9331 53.8034 58.4409 54.2948 57.8119 54.2948Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1446">
          <rect width="90" height="90" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
